import React, { useState, useEffect, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";
import LoadingBar from 'react-top-loading-bar'
import {Helmet} from "react-helmet";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import MusicBox from "../Global/MusicBox";
import Spinner from "../Global/Spinner";

import './music.css';
import styles from "../../App.module.css";
// import classes from "./Music.module.css";
import Header from "../Header/Header";
// import Sidebar from "../Sidebar/Sidebar";
import EmptyContent from "../Global/EmptyContent";

import noThumb from "../../images/no-thumb.jpg";
import Categories from "../Categories/Categories";

const Sidebar = lazy(() => import('../Sidebar/Sidebar'))

function Musics() {
  const [type, setType] = useState('');
  const [musics, setMusics] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [hasMore, sethasMore] = useState(true);
  const [page, setPage] = useState(2);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(10);

  useEffect(() => {
    try{
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }catch(ex){}
  }, []);

  useEffect(() => {
    if(tabIndex === 0) {
      setType('');
    }else if(tabIndex === 1) {
      setType('mostviewed');
    }else if(tabIndex === 2) {
      setType('mostliked');
    }else if(tabIndex === 3) {
      setType('mostcom ');
    }else if(tabIndex === 4) {
      setType('promoted');
    }

    setPage(2);
    setMusics([]);
  }, [tabIndex]);

  useEffect(() => {
    setProgress(20);
    axios.get(`${process.env.REACT_APP_API_URL}/api/musics.php?type=${type}&page=1&limit=12`)
    .then(response => {
        // console.log(response.data);
        setMusics(response.data);
        response.data.length < 12 ? sethasMore(false) : sethasMore(true);
        setLoading(true);
        setProgress(100);
    })
  }, [type]);

  const loadMore = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/musics.php?type=${type}&page=${page}&limit=12`)
    .then(response => {
      if(response.data.message !== 'No videos found') {
        loading && hasMore && setMusics([...musics, ...response.data]);
        setPage(page + 1);
        
        response.data.length < 12 ? sethasMore(false) : sethasMore(true);
      }
    })
  };

  return (
    <>
      <Helmet>
        <title>Music</title>
        <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
        <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar active="music" />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <ins className='adsbygoogle p-4 pb-0'
              style={{ display: 'block' }}
              data-ad-client='ca-pub-8126596259429304'
              data-ad-slot='5153011292'
              data-ad-format='auto'
            />
            <Categories type="2" />
            <div className="music-component p-4">
              <div className="h3">
                <span>Music</span>
              </div>
              {/* <div className="sec-tabs mb-2">
                <ul className="d-inline">
                  <li>
                      <a href="/" className="active">Recent</a>
                  </li>
                  <li><a href="/">Most Listened</a></li>
                  <li><a href="/">Most Liked</a></li>
                  <li><a href="/">Discussed</a></li>
                  <li><a href="/">Featured</a></li>
                </ul>
              </div> */}
              <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index) }>
                <TabList>
                    <Tab>Recent</Tab>
                    <Tab>Top</Tab>
                    <Tab>Most Liked</Tab>
                    <Tab>Discussed</Tab>
                    <Tab>Featured</Tab>
                </TabList>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
              </Tabs>
              <div className="musics">
                {
                  musics && musics.map ? <InfiniteScroll
                    pageStart={0}
                    loadMore={loadMore}
                    hasMore={hasMore}
                    loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                    className="row m-0"
                  >
                    {
                      musics && musics.map && musics.map((music, index) => {
                          return (
                            <div key={index} className="col-11">
                              {
                                 MusicBox(music)
                              }
                            </div>
                          )
                      })
                    }
                  </InfiniteScroll>
                  : <EmptyContent />
                }
              </div>
            </div>
          </div>
        </Suspense>
      </div>
    </>
  );
}

export default Musics;
